var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 590.00964 472.784",
    xmlSpace: "preserve",
    width: 590.00964,
    height: 472.784,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    style: {
      fill: "#800000"
    },
    transform: "translate(86.20779,-46.978508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6-2",
    style: {
      fill: "#90ce84",
      fillOpacity: 1
    },
    transform: "matrix(-1,0,0,1,503.79221,38.370508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4-9",
    style: {
      fill: "#90ce84",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 516.25,214.562 -221.25361,180.953 -0.001,-59.287 C 368.74758,275.81014 442.49862,215.39085 516.25,154.972 v 59.59 M 590,240.122 V 8.608 L 294.99518,250.28 v 231.112 z",
    id: "path2-7",
    style: {
      fill: "#90ce84",
      fillOpacity: 1,
      strokeWidth: 1.09731
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g6-2-8",
    style: {
      fill: "#90ce84",
      fillOpacity: 1
    },
    transform: "translate(-86.19815,38.370508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4-9-2",
    style: {
      fill: "#90ce84",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 516.25,214.562 -221.25361,180.953 -0.001,-59.287 C 368.74758,275.81014 442.49862,215.39085 516.25,154.972 v 59.59 M 590,240.122 V 8.608 L 294.99518,250.28 v 231.112 z",
    id: "path2-7-5",
    style: {
      fill: "#90ce84",
      fillOpacity: 1,
      strokeWidth: 1.09731
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g20",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    style: {
      fill: "#800000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    style: {
      fill: "#800000"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(86.20779,-46.978508)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(86.20779,-46.978508)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(86.20779,-46.978508)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(86.20779,-46.978508)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(86.20779,-46.978508)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(86.20779,-46.978508)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(86.20779,-46.978508)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(86.20779,-46.978508)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(86.20779,-46.978508)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(86.20779,-46.978508)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(86.20779,-46.978508)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(86.20779,-46.978508)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(86.20779,-46.978508)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(86.20779,-46.978508)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(86.20779,-46.978508)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.0b332a981b8ef2946b7f160aff717b81.svg";
export { ForwardRef as ReactComponent };